// libs/shared-vault/data-access/src/lib/vault-config.token.ts
import { InjectionToken } from '@angular/core';

export interface VaultConfig {
  apiUrl: string;
  loginUrl: string;
  /** Minutos sin interacción antes de cerrar sesión; 0 = solo expiración por token (default 1440 = 24 h). */
  sessionInactivityMinutes?: number;
  /** Minutos de aviso previo al cierre por inactividad (default 5). */
  sessionWarningMinutes?: number;
}

export const VAULT_CONFIG = new InjectionToken<VaultConfig>('VAULT_CONFIG');
